import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { actionsSearcher, SearcherState } from '@vueling-ng/vy-cdk-searcher';
import { StaticsService } from 'app/services/internal/static/statics.service';
import { StateManagerService } from 'app/shared/state/state-manager.service';
import { tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HomeService {
  private readonly _stateManagerService = inject(StateManagerService);
  private readonly _staticsService = inject(StaticsService);
  private readonly _store = inject(Store<SearcherState>);

  public reloadStatics(language: string): void {
    this._staticsService
      .getStatics(language)
      .pipe(
        tap(({ stations, countries }) => {
          this._stateManagerService.update((draft) => {
            draft.stations = stations;
            draft.countries = countries;
          });
          this._store.dispatch(actionsSearcher.loadOrigins());
        })
      )
      .subscribe();
  }
}
